/**
 * dataURL(base64)을 File 객체로 변환
 * @param dataurl dataURL 문자열 (예: "data:image/jpeg;base64,...")
 * @param filename 파일명
 * @returns File 객체
 */
export const dataURLtoFile = (dataurl: string, filename: string): File => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/jpeg'
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

/**
 * File 객체를 base64(dataURL)로 변환
 * @param file File 객체
 * @returns Promise<string> base64 문자열
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result)
      } else {
        reject(new Error('FileReader 결과가 문자열이 아닙니다.'))
      }
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
